import React, { useState } from "react";
import { Link } from "react-router-dom";
import useSticky from "../../hooks/use-sticky";
import Menus from "./Menus";
import OffCanvas from "./OffCanvas";

// Define the props interface
interface MenuProps {
  header_style_2?: boolean;
}

const Menu: React.FC<MenuProps> = ({ header_style_2 }) => {
  // const [isToggleSearch, setToggleSearch] = useState<boolean>(false);
  const [isOffCanvas, setOffCanvas] = useState<boolean>(false);

  // Assuming that useSticky is returning an object with a boolean `sticky`
  const { sticky }: { sticky: boolean } = useSticky();

  return (
    <>
      <header>
        <div
          id="header-sticky"
          className={`header__area  ${header_style_2
            ? "header__area-2 pl-110 pr-110"
            : "header__transparent pr-90 pl-90"
            } header-sticky-active  ${sticky ? "header-sticky" : ""}`}
          style={{ height: sticky ? "90px" : "100px" }}
        >
          {/* Header content */}


          <div className="header__main" id="header-sticky">
            <div className="container-fluid " style={{ marginTop: '-15px' }}>
              <div className="row ">
                <div className="col-lg-2 col-md-4 col-7">
                  <div className="logo">
                    <Link to="/">
                      <img
                        src={
                          "assets/img/logo/clubnet_logo .png"
                        }
                        className="w-75 mt-4"
                        alt="logo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-9 col-md-4 d-none d-md-block">
                  <div
                    className={`main-menu ${header_style_2 ? "normal-menu" : ""
                      } text-center`}
                  >
                    <nav id="mobile-menu" className="d-none d-xl-block">
                      <Menus />
                    </nav>
                  </div>
                </div>
                <div className="col-2  mt-40">
                  <div className="header__main_right d-flex justify-content-end align-items-center ">
                    {/* <div className="tp-header-search-icons normal-search mr-80 p-relative">
                      <div
                        className={`search-btn-wrap ${
                          isToggleSearch ? "header_search-open" : ""
                        }`}
                      >
                        <button
                          onClick={() => setToggleSearch(!isToggleSearch)}
                          className="button-search-toggle position-relative"
                        >
                          <i
                            className={`header_search-button ${
                              header_style_2 ? "" : "text-white"
                            } far fa-search`}
                          ></i>
                          <i
                            className={`header_search-close ${
                              header_style_2 ? "" : "text-white"
                            } far fa-times`}
                          ></i>
                        </button>
                        <div className="tp-search-form p-relative">
                          <form action="#">
                            <input type="text" placeholder="Search ..." />
                            <button
                              type="submit"
                              className="search-submit-icon"
                            >
                              <i className="far fa-search"></i>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div> */}
                    <div
                      className={`tp-bar-icon ${header_style_2 ? "tp-bar-icon-dark" : ""
                        }`}
                    >
                      <button
                        onClick={() => setOffCanvas(true)}
                        className="offcanvas-toggle-btn d-block d-xl-none"
                      >
                        <i className="fal fa-bars" />
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* off canvas start */}
      <OffCanvas isOffCanvas={isOffCanvas} setOffCanvas={setOffCanvas} />
      {/* off canvas end */}
    </>
  );
};

export default Menu;
